import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth token in localStorage (httpOnly cookies work too — we send both)
export const getToken = () => localStorage.getItem("race377_token");
export const setToken = (t) => localStorage.setItem("race377_token", t);
export const clearToken = () => localStorage.removeItem("race377_token");

const client = axios.create({ baseURL: API, withCredentials: true });
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default client;

// ===== Articles =====
export const articlesAPI = {
  list: (params = {}) => client.get("/articles", { params }),
  getBySlug: (slug) => client.get(`/articles/${slug}`),
  featured: () => client.get("/articles/featured"),
};

// ===== Categories =====
export const categoriesAPI = {
  list: () => client.get("/categories"),
};

// ===== Auth =====
export const authAPI = {
  login: (email, password) => client.post("/auth/login", { email, password }),
  logout: () => client.post("/auth/logout"),
  me: () => client.get("/auth/me"),
};

// ===== Admin Articles =====
export const adminAPI = {
  list: (params = {}) => client.get("/admin/articles", { params }),
  get: (id) => client.get(`/admin/articles/${id}`),
  create: (data) => client.post("/admin/articles", data),
  update: (id, data) => client.patch(`/admin/articles/${id}`, data),
  remove: (id) => client.delete(`/admin/articles/${id}`),
  feature: (id) => client.post(`/admin/articles/${id}/feature`),
  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post("/admin/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};

// Build absolute URL for backend-served paths like "/api/files/..."
export const absUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
};

// ===== Legacy (kept) =====
export const contactAPI = {
  submit: (data) => client.post("/contact", data),
};
export const newsletterAPI = {
  subscribe: (email) => client.post("/newsletter", { email }),
};
